<template>
  <v-row no-gutters align="center">
    <v-col cols="3">
      <v-text-field
        v-model="contact.value"
        outlined
        dense
        placeholder="Contato não informado"
        :readonly="true"
      >
        <template v-slot:label>
          <div>
            {{ contactName }}
          </div>
        </template>
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "PatientContact",
  props: {
    contact: Object,
  },
  data() {
    return {
      patientContact: null,
      contactName: String,
    };
  },
  mounted() {
    if (this.contact.name === "Casa") this.contactName = "Telefone";
    else this.contactName = this.contact.name;
  },
};
</script>
